module.exports = __webpack_public_path__ + "img/2_51.0435b0c3.png";